import Swiper, { Navigation, Pagination } from 'swiper';

const presentationCarousels = document.querySelectorAll('.presentations__list');

Swiper.use([Navigation, Pagination]);
let slidersArray = [];
presentationCarousels.forEach((section, i) => {
    let init = false;
    if (!init) {
        init = true;
        if (section.querySelector('.swiper-wrapper')) {
            const carousel = new Swiper(section, {
                slideActiveClass: 'is-active',
                breakpoints: {
                    0: {
                        slidesPerView: 1.4,
                        spaceBetween: 16,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
                pagination: {
                    el: section.parentElement.querySelector(
                        '.swiper-pagination-news'
                    ),
                    type: 'bullets',
                    bulletClass: 'bottom-pagination__bullet',
                    bulletActiveClass: 'active',
                },
                navigation: {
                    nextEl: section.parentElement.parentElement.querySelector(
                        '.slider-arrow--next'
                    ),
                    prevEl: section.parentElement.parentElement.querySelector(
                        '.slider-arrow--prev'
                    ),
                },
            });
            slidersArray.push(carousel);
        }
    }
});
